import { render, staticRenderFns } from "./basketMenu.vue?vue&type=template&id=ae334bec&"
import script from "./basketMenu.vue?vue&type=script&lang=js&"
export * from "./basketMenu.vue?vue&type=script&lang=js&"
import style0 from "./basketMenu.vue?vue&type=style&index=0&id=ae334bec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports